<template>
	<div class="container_main">
		<div class="search_form">
			<Form class="ant-advanced-search-form" :form_data="form_data_seo" @handleSubmit="handleSubmit"
				@handleReset="handleReset" ref="form_seo"></Form>
		</div>
		<div class="list_main">
			<div class="list_right">
				<TableList :is_created_get_list='false' :columns="columns" :get_table_list="get_table_list" :where="where"
					:slot_table_list="['operation','status_name']" ref="list" :rowKey="'id'" :style_mode="''">
					<template slot="status_name" slot-scope="data">
						<span v-if="data.record.status == 1" class="status_box"
							@click="getMaterialStatus(data.record)">启用</span>
						<span v-else class="status_box" style="background:red;"
							@click="getMaterialStatus(data.record)">禁用</span>
					</template>
					<template slot="operation" slot-scope="data">
						<a @click="getAddSave(data.record,'edit')">编辑</a>
						<a-divider type="vertical" />
						<a @click="getDelete(data.record)">删除</a>
					</template>
				</TableList>
			</div>
		</div>
		<a-modal width='30%' v-model:visible="productShow" :title="from.id ? '编辑产线' : '新增产线'" @ok="productOk">
			<a-form :label-col="labelColEdit" :wrapper-col="wrapperColEdit">
				<a-form-item required name='name' label="产线名称"
					:rules="[{ required: true, message: '产线名称不能为空',tagger:'blur' }]">
					<a-input v-model:value="from.name" placeholder="请输入产线名称" />
				</a-form-item>
				<a-form-item required label="所属工厂">
					<a-select v-model:value="from.factory_id" style="width: 100%"
						:dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择" allow-clear>
						<a-select-option :value="item.id" v-for="(item,index) in FactorySelect"
							:key="index">{{ item.label }}</a-select-option>
					</a-select>
				</a-form-item>
			</a-form>
		</a-modal>

	</div>
</template>
<script>
	import Form from "@/components/Form"
	import TableList from "@/components/TableList";
	import {
		message,
		Modal
	} from 'ant-design-vue';
	import {
		getLineList,
		getLineDetail,
		deleteLine,
		changeLineStatus,
		saveLineInfo,
		getFactorySelect
	} from '@/api/qms.js'

	const columns = [{
			title: "ID号",
			dataIndex: "id",
		},

		{
			title: "产线名称",
			dataIndex: "name",
		},
		{
			title: "所属工厂",
			dataIndex: "factory_name",
		},
		{
			title: "产线状态",
			dataIndex: "status_name",
			scopedSlots: {
				customRender: "status_name"
			}
		},
		{
			title: "创建时间",
			dataIndex: "create_time",
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			}
		}
	];

	export default {
		
		components: {
			TableList,
			Form
		},
		data() {
			return {
				columns,
				form_data_seo: {
					...this.$config.form_data_seo,
					list: [{
						type: "text",
						name: "keyword",
						title: "关键词",
						placeholder: "请输入产线名称",
						options: {}
					}, ],
				},

				labelColEdit: {
					span: 4
				},
				wrapperColEdit: {
					span: 18
				},

				productShow: false,
				from: {
					id: '',
					name: '',
				},
				FactorySelect: [],

				where: {
					keyword: '',
					factory_id:'',
				},
				get_table_list: getLineList,

			}
		},
		created() {
			this.getFactorySelect()
		},
		
		methods: {
			productOk() {
				saveLineInfo({
					...this.from
				}).then(res => {
					this.productShow = false
					message.success('保存成功');
					this.from = {}
					this.$refs.list.get_list()
				})
			},
			getFactorySelect() {
				getFactorySelect({
					is_page: 0
				}).then(res => {
					this.FactorySelect = res.data.list
				})
			},
			reset() {
				this.$refs.form_seo.handleReset()
				this.where.keyword = null
				this.where.factory_id= this.where.factory_id
				this.$refs.list.get_list()
			},
			handleSubmit(e) {
				this.where.keyword = e.values.keyword
				this.$refs.list.get_list()
			},
			getAddSave(info, type) {
				//编辑数据
				this.from.id = info.id
				this.from.factory_id = info.factory_id > 0 ? info.factory_id : ''
				this.from.name = info.name
				this.productShow = true
			},



			getDelete(info) {
				let that = this
				Modal.confirm({
					title: '温馨提示',
					content: '确定要删除产线【' + info.name + '】吗？',
					okText: '确定',
					cancelText: '取消',
					onOk() {
						deleteLine({
							id: info.id
						}).then(res => {
							message.success('删除成功');
							that.$refs.list.get_list()
						})
					}
				});
			},

			getMaterialStatus(info) {
				let text = info.status == 1 ? "禁用" : "启用"
				let that = this
				Modal.confirm({
					title: '温馨提示',
					content: '确定要' + text + '产线【' + info.name + '】吗？',
					okText: '确定',
					cancelText: '取消',
					onOk() {
						changeLineStatus({
							id: info.id,
							status: info.status == 1 ? 0 : 1
						}).then(res => {
							message.success('操作成功');
							that.$refs.list.get_list()
						})
					}
				});
			},

		}
	}
</script>

<style lang="less" scoped>
	.container_main {
		// padding: 15px;
	}

	.search_form {
		// padding: 15px 15px 0px 15px;
		background: #ffffff;
	}

	.list_main {
		margin-top: 15px;
		display: flex;
		background: #ffffff;

		.list_left {
			width: 260px;

			.left_main {
				width: 100%;
			}
		}
		.list_right {
			width: calc(100% - 0px);
			// padding: 15px;
		}
	}

	.FieldSettingsBox {
		border: none;
		border-right: 1px solid #eeeeee;
		margin-top: 12px;
		height: auto;
		padding-left: 15px;
	}

	.FieldSettingsBoxTitle {
		display: flex;
		width: 100%;
		padding: 8px 12px 8px 0px;
		border-bottom: 1px solid #eeeeee;
		justify-content: space-between;
	}

	.show_type {
		border-left: 3px solid #0079FF;
		padding-left: 10px;
		font-weight: bold;
	}

	.show_type_setting {
		text-align: right;
		color: #397dee;
		cursor: pointer;
	}

	.status_box {
		background: #1890ff;
		padding: 1px 5px 3px 5px;
		color: #ffffff;
		border-radius: 2px;
		font-size: 12px;
		cursor: pointer;
		display: inline-block;
		min-width: 34px;
	}

	/deep/.ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon {
		color: #666;
		font-size: 16px;
	}

	/deep/.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-tree-switcher-icon,
	/deep/.ant-tree li span.ant-tree-switcher.ant-tree-switcher_open .ant-select-switcher-icon {
		color: #333;
		font-size: 16px;
	}

	/deep/.ant-tree-node-content-wrapper {
		width: calc(100% - 36px);
	}

	.tree_title_main {
		width: 100%;
		position: relative;

		.title_op {
			display: flex;
			position: absolute;
			top: 0;
			right: 0;
			background: red;
		}
	}
</style>